import { Settings } from 'lucide-react';

export default function EditButton({ onClick }) {
  return (
    <button
      onClick={onClick}
      className="fixed bottom-6 right-6 z-50 w-14 h-14 bg-gradient-to-r from-purple-500 to-pink-500 rounded-full flex items-center justify-center shadow-lg hover:shadow-purple-500/50 transition-all hover:scale-110"
      title="编辑网站"
    >
      <Settings className="w-6 h-6 text-white" />
    </button>
  );
}
